import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/administrativo/cargos${queryUrl}`)
  },
  insertNewExecutiePosition(data) {
    return axios.post('/administrativo/cargos/', data)
  },
  editExecutiePosition(data) {
    return axios.put(`/administrativo/cargos/${data.id}`, data)
  },
  deleteExecutiePosition(id) {
    return axios.delete(`/administrativo/cargos/${id}`)
  },
}
